import { Checkbox, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOnTimeDetail extends Layout {
    checkboxExcludeCustomers: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeServiceFailureNf: Checkbox;
    checkboxIncludeConsigneeStops: Checkbox;
    checkboxIncludeExtraStops: Checkbox;
    checkboxIncludeShipperStops: Checkbox;
    labelAdded: Label;
    labelDividendIncidents: Label;
    labelDividendLate: Label;
    labelDividendNoIncident: Label;
    labelDividendOnTime: Label;
    labelDivisorIncidents: Label;
    labelDivisorLate: Label;
    labelDivisorNoIncident: Label;
    labelDivisorOnTime: Label;
    labelLeftParenIncidents: Label;
    labelLeftParenLate: Label;
    labelLeftParenNoIncident: Label;
    labelLeftParenOnTime: Label;
    labelRightParenIncidents: Label;
    labelRightParenLate: Label;
    labelRightParenNoIncident: Label;
    labelRightParenOnTime: Label;
    labelScoreDetailsIncidents2: Label;
    labelScoreDetailsIncidents3: Label;
    labelScoreDetailsLate2: Label;
    labelScoreDetailsLate3: Label;
    labelScoreDetailsLate4: Label;
    labelScoreDetailsNoIncident2: Label;
    labelScoreDetailsNoIncident3: Label;
    labelScoreDetailsOnTime2: Label;
    labelScoreDetailsOnTime3: Label;
    labelScoreDetailsOnTime: Label;
    labelScoringDetailsIncidents: Label;
    labelScoringDetailsLate: Label;
    labelScoringDetailsNoIncident: Label;
    labelSelectAMeasure: Label;
    labelStopsToInclude: Label;
    labelSubtracted: Label;
    labelWeightIncidents: Label;
    labelWeightLate: Label;
    labelWeightNoIncident: Label;
    labelWeightOnTime: Label;
    panelFormulaIncidents: Panel;
    panelFormulaLate: Panel;
    panelFormulaNoIncident: Panel;
    panelFormulaOnTime: Panel;
    panelGracePeriod: Panel;
    panelIncidents: Panel;
    panelLate: Panel;
    panelLateStops: Panel;
    panelNoIncident: Panel;
    panelNoMeasure: Panel;
    panelOnTime: Panel;
    panelStopsToInclude: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxAdditionalWeight: Textbox;
    textboxAverageMinutesLate: Textbox;
    textboxCustomerId: Textbox;
    textboxEndOfPeriod: Textbox;
    textboxGracePeriodOnTime: Textbox;
    textboxMeasure: Textbox;
    textboxMinimumRecords: Textbox;
    textboxOrderType: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
